import Arrow from '../../CommonComponents/Arrow/Arrow';
import { BallLaunch } from 'services/Calculator/CalculatorService';
import BallWithArrow from '../../CommonComponents/BallWithArrow/BallWithArrow';
import { CalculatorOptions } from 'types/calculator/CalculatorOptions';
import CurrentClub from '../../CommonComponents/CurrentClub/CurrentClub';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { useStores } from 'index';

type Props = {
  calcOptions: CalculatorOptions;
  calcResult: BallLaunch;
};

const TopClub = observer(({ calcOptions, calcResult }: Props) => {
  const cs = useStores().calculatorStore;
  const isLoadingCalcResult = useMemo(() => cs.isLoading, [cs.isLoading]);

  return (
    <>
      <Arrow
        color={'blue'}
        leftToRotationPoint={`20px`}
        topToRotationPoint={`50%`}
        rotationInDegrees={-(calcOptions.calculators.c?.ClubPath ?? 0)}
        length={`${((calcOptions.calculators.o?.ClubSpeed ?? 0) / 100) * 35}%`}
        scale={0.02}
      />
      <BallWithArrow
        leftToRotationPoint={`20px`}
        topToRotationPoint={`50%`}
        length={`${(calcResult.LaunchData.BallSpeed / 100) * 35}%`}
        rotation={-calcResult.LaunchData.LaunchDirection}
        className={isLoadingCalcResult ? 'animate-pulse' : ''}
        scale={0.02}
      />
      <CurrentClub
        view='top'
        calcOptions={calcOptions}
        leftToHitPoint={`20px`}
        topToHitPoint={`50%`}
        style={{ height: '8px' }}
        rotation={calcOptions.calculators.c?.FaceAngle}
      />
    </>
  );
});

export default TopClub;
